import { createAsyncReducer } from '../../standard-actions';
import {
    ILoadNbnAction,
    ILoadNbnSuccessAction,
    ILoadNbnErrorAction,
    IUpdateNbnServiceListAction,
    IUpdateNbnServiceListPaginationAction
} from '../actions/load-nbn-service-list';
import { IServiceRequestsState } from '../state';
import { initialState } from '../state/initial-state';
import { AsyncActionState } from '@telstra-connect/standard-actions/async-action';

export type LoadNbnServiceAction
    = ILoadNbnAction
    | ILoadNbnSuccessAction
    | ILoadNbnErrorAction

export type UpdateNbnServiceListAction = IUpdateNbnServiceListAction;
export type UpdateNbnServiceListPaginationAction = IUpdateNbnServiceListPaginationAction;
const init = (state: IServiceRequestsState, action: LoadNbnServiceAction) => ({
    ...state,
    nbnServiceListDetails: {
        ...state.nbnServiceListDetails,
        status: action.status
    }
});

const success = (state: IServiceRequestsState, action: LoadNbnServiceAction) => ({
    ...state,
    nbnServiceListDetails: {
        ...initialState.nbnServiceListDetails,
        status: action.status,
        data: (action as ILoadNbnSuccessAction).data
    }
});

const failure = (state: IServiceRequestsState, action: LoadNbnServiceAction) => ({
    ...state,
    nbnServiceListDetails: {
        ...state.nbnServiceListDetails,
        status: action.status,
        error: (action as ILoadNbnErrorAction).error
    }
});

export const updateServiceListReducer = (state: IServiceRequestsState,
    action: UpdateNbnServiceListAction) => {
    const prevServices = state.nbnServiceListDetails.data.nbnServices;
    action.services.sort((a, b) => (a.serviceNumber > b.serviceNumber) ? 1 :
        (b.serviceNumber > a.serviceNumber) ? - 1 : 0).reverse();
    const services = prevServices.concat(action.services);
    const pageIndexList = state.nbnServiceListDetails.data.pageIndexList;
    pageIndexList.push({pageIndex: action.pageIndex, callAt: state.nbnServiceListDetails.data.callApiPosition++});
    return {
        ...state,
        nbnServiceListDetails: {
            ...state.nbnServiceListDetails,
            data: {
                ...state.nbnServiceListDetails.data,
                nbnServices: services
            },
            pageIndexList,
            status: AsyncActionState.Success
        }
    };
}

export const updateServiceListPaginationReducer = (state: IServiceRequestsState,
    action: UpdateNbnServiceListPaginationAction) => {
    return {
        ...state,
        nbnServiceListDetails: {
            ...state.nbnServiceListDetails,
            data: {
                ...state.nbnServiceListDetails.data,
                pagination: action.pagination
            }
        }
    };
}
export const loadNbnServiceReducer = createAsyncReducer(initialState, init, success, failure);
